import React, { useContext } from 'react';
import trans from 'translate';
import { signTradeOrdersCols } from '../SignTradeOrders/columns';
import SignTradeOrders from '../SignTradeOrders/SignTradeOrders';
import OrdersTabs from './OrdersTabs/OrdersTabs';
import { OrdersContext } from '../../../../Modals/EditTokensModal/EditOrderDetails';
import './EditTradeOrders.scss';
import { editTradeOrders } from './cols/editTradeOrderCols';

const EditTradeOrders = () => {
  const { selectedToken } = useContext(OrdersContext);
  return (
    <div className="edit-order-wrapper">
      <p className="font-light color-main font-lg">{trans('hpool.current_position')}</p>
      <div className="trades-table-wrapper">
        <SignTradeOrders tradeOrders={[selectedToken]} cols={editTradeOrders} hiddenCols={['_edit', '_status']} />
      </div>
      <OrdersTabs />
    </div>
  );
};

export default EditTradeOrders;
